module.exports = __webpack_public_path__ + "static/img/4introduce.853a1b3c.png";